<template>
    <div class="fileWrap">
        <a href="javascript:void(0);" class="input-wrap">
            <el-button type="primary">上传图标</el-button>
            <input type="file"  @change="fileChange">
        </a>
        <div class="file-content">
            <p v-for="( item,i ) in data" :key="i">
                <span><img :src="item.url" alt=""></span>
                <a :href="item.url">{{ item.name }}</a>
                <i class="iconfont icon-shanchu"　@click="delTab(item,i)"></i>
            </p>
        </div>
    </div>
</template>

<script>
    import commonService from "../../services/common.service"
    export default {
        props:{
            data:Array,
            getFiles:Function
        },
        data() {
            return {

            }
        },
        created() {

        },
        methods: {
            fileChange(e){
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length){
                    return;
                };
                let params = { file_name:files[0] };
                commonService.uploading(params).then(res => {
                    this.data.push({
                        name:res.file_name,
                        url:res.download_url
                    })
                    this.getFiles(this.data);
                }).catch( err => {
                    this.$message.error(err.message);
                })
            },
            delTab(item,i){
                this.data.splice(i,1);
                this.getFiles(this.data);
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

    .fileWrap{
        position: relative;
        width:100%;
        input{
            display: inline-block;
            width:100%;
            height: 100%;
            position: absolute;
            opacity: 0;
            filter:alpha(opacity=0);
            left:0;
            top:0;
        }
        .input-wrap {
            text-decoration:none;
            width:100px;
            height:30px;
            line-height:30px;
            display:inline-block;
            overflow:hidden;
            position:relative;
            text-align: center;
            top:0;
            cursor: pointer;
            .el-button{
                display:inline-block;
                width:100%;
                height:100%;
                cursor: pointer;
                text-align: center;
            }
        }

    }
    .file-content{
        p{
            width:300px;
        }
        i{
            float: right;
            cursor: pointer;
            color: #F37258;
            position: relative;
            top: 54px;
        }
        span{
            display: inline-block;
            img{
                display: block;
                height: 60px;
                width: 60px;
            }
        }
        a{
            position: relative;
            top: 10px;
            left: -60px;
        }
    }
</style>
